import { watch } from 'vue';
import { useDocumentRevisionSearch, useDocumentRefreshStore } from '@/entities/Document';
import { SearchParams } from '@/shared/lib';

/**
 * Checks if a URL corresponds to an approval or verification page
 * @param searchUrl - The URL to check
 * @returns True if the URL is an approval or verification page
 */
function isApprovalOrVerificationPage(searchUrl: string | undefined): boolean {
  if (!searchUrl) return false;

  // As abas de Registro leem a matriz, entao a URL delas nao comeca por /document-revisions. Sem
  // reconhece-las aqui, a lista para de se atualizar sozinha depois de uma decisao, em silencio.
  const awaitingApprovalPattern =
    /\/(?:document-revisions|matrices)\/awaiting-approval(?:\/|$)/;
  const awaitingVerificationPattern =
    /\/(?:document-revisions|matrices)\/awaiting-verification(?:\/|$)/;

  return awaitingApprovalPattern.test(searchUrl) || awaitingVerificationPattern.test(searchUrl);
}

export default function useApprovalOrVerificationSearch(params: SearchParams) {
  const searchComposable = useDocumentRevisionSearch(params);

  const documentRefreshStore = useDocumentRefreshStore();

  const handleDocumentRefresh = async () => {
    if (isApprovalOrVerificationPage(params.searchUrl)) {
      await searchComposable.initSearch();
    }
  };

  watch(() => documentRefreshStore.refreshTrigger, handleDocumentRefresh);

  return {
    ...searchComposable,
    handleDocumentRefresh,
  };
}
